import { AUTH_LOGOUT, CLEAR_PIPELINE_FILTERS, SET_PIPELINE_FILTERS } from '../actions'

export interface IPipelineFilters {
  dateRange: { from: string | null; to: string | null }
  query: string
  rush: string
  status: Record<string, boolean>
  lock: string
  state: string
  maturity: string
  type: string
  productType: string
  myLoans: boolean
  orderBy: string
  orderDir: string
  pipelineType: any
}

const initialState: IPipelineFilters = {
  dateRange: { from: null, to: null },
  query: '',
  rush: 'all',
  status: {},
  lock: '0',
  state: '',
  maturity: '0',
  type: '0',
  productType: '0',
  myLoans: true,
  orderBy: 'asOf',
  orderDir: '-1',
  pipelineType: '',
}

export default function pipelineReducer(state = initialState, action: any): IPipelineFilters {
  switch (action.type) {
    case SET_PIPELINE_FILTERS:
      return {
        ...state,
        ...action.payload,
      }

    case CLEAR_PIPELINE_FILTERS:
    case AUTH_LOGOUT:
      return initialState

    default:
      return state
  }
}
